import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import ScrollUp from '../Components/ScrollUp'

export default function PricingPlan() {
  return (
    <>
      <section id="scroll-up">

        {/* <!-- back-to-top-start  --> */}
        <ScrollUp />
        {/* <!-- back-to-top-end  --> */}
        
        <div id="smooth-wrapper">
          <div id="smooth-content">

            <main>
              <Header />
              {/* <!-- breadcrumb-area-start --> */}
              <div className="breadcrumb__area breadcrumb-ptb-5 p-relative blue-bg-2">
                <div className="breadcrumb__shape-1">
                  <img src="/img/breadcrumb/breadcrumb-shape-1.png" alt="" />
                </div>
                <div className="breadcrumb__shape-2">
                  <img src="/img/breadcrumb/breadcrumb-shape-2.png" alt="" />
                </div>
                <div className="container">
                  <div className="row align-items-end">
                    <div className="col-xl-9 col-lg-7 col-md-7">
                      <div className="price-banner z-index-3">
                        <div className="price-banner-title-box">
                          <h3 className="price-banner-title tp-char-animation">Pricing plans</h3>
                          <p>Clear, affordable plans for every business and their requirements.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- breadcrumb-area-end --> */}

              {/* <!-- tp-price-area-start --> */}
              <div className="tp-price-area mb-120">
                <div className="container">
                  <div className="price-tab-content">
                    <div className="tab-content" id="nav-tabContent">
                      <div className="tab-pane fade show active" id="nav-home" role="tabpanel"
                        aria-labelledby="nav-home-tab" tabindex="0">
                        <div className="tp-price-table price-inner-white-bg z-index-3">
                          <div className="tp-price-table-wrapper">
                            <div className="row g-0 align-items-center">
                              <div className="col-4">
                                <div className="tp-price-header">
                                  <div className="tp-price-header-img">
                                    <img src="/img/price/price-4.1.png" alt="" />
                                  </div>
                                  <div className="tp-price-header-content">
                                    <p>Try free trial for
                                      <span> 15 days</span> <br />for your business.</p>
                                  </div>
                                </div>
                              </div>
                              <div className="col-8">
                                <div className="tp-price-top-wrapper">
                                  <div className="tp-price-top-item text-center">
                                    <div className="tp-price-top-tag-wrapper">
                                      <span>
                                        <h5><b> TRIAL PLAN</b></h5>
                                      </span>
                                    </div>
                                    <div className="tp-price-top-title-wrapper">
                                      <h4><i className="fa-solid fa-indian-rupee-sign"></i> 0 *<span>/ Month</span>
                                      </h4>
                                    </div>
                                    <div className="tp-price-top-title-wrapper">
                                      <h5><i className="fa-solid fa-indian-rupee-sign"></i> 0 *<span>/ 15 Days</span>
                                      </h5>
                                      <a className="tp-btn-service mt-5" href=".">Get Started</a>
                                    </div>
                                  </div>
                                  <div className="tp-price-top-item text-center">
                                    <div className="tp-price-top-tag-wrapper">
                                      <span>
                                        <h5><b>STANDARD PLAN</b></h5>
                                      </span>
                                    </div>
                                    <div className="tp-price-top-title-wrapper">
                                      <h4><i className="fa-solid fa-indian-rupee-sign"></i> 250
                                        *<span>/ Month</span>
                                      </h4>
                                    </div>
                                    <div className="tp-price-top-title-wrapper">
                                      <h5><i className="fa-solid fa-indian-rupee-sign"></i> 2999
                                        *<span>/ 1 Year</span>
                                      </h5>
                                      <a className="tp-btn-service mt-5" href=".">Get Started</a>
                                    </div>
                                  </div>
                                  <div className="tp-price-top-item text-center">
                                    <div className="tp-price-top-tag-wrapper">
                                      <span>
                                        <h5><b>ENTERPRISE PLANE</b></h5>
                                      </span>
                                    </div>
                                    <div className="tp-price-top-title-wrapper">
                                      <h4><i className="fa-solid fa-indian-rupee-sign"></i> 375
                                        *<span>/ Month</span>
                                      </h4>
                                    </div>
                                    <div className="tp-price-top-title-wrapper">
                                      <h5><i className="fa-solid fa-indian-rupee-sign"></i> 4499
                                        *<span>/ 1 Year</span>
                                      </h5>
                                      <a className="tp-btn-service mt-5" href=".">Get Started</a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="tp-price-feature-wrapper">
                              <div className="row g-0">
                                <div className="col-4">
                                  <div className="tp-price-feature-box">
                                    <div className="tp-price-feature-item p-relative">
                                      <div>
                                        <span>Software Users:</span>
                                      </div>
                                      <div className="tp-price-feature-tooltip">
                                        <p>Add gradient heading, button, pricing table testimonial etc.</p>
                                      </div>
                                    </div>
                                    <div className="tp-price-feature-item p-relative">
                                      <span>Number Of Company:</span>
                                      <div className="tp-price-feature-tooltip">
                                        <p>Add gradient heading, button, pricing table testimonial etc.</p>
                                      </div>
                                    </div>
                                    <div className="tp-price-feature-item p-relative">
                                      <span>Number Of Staff User:</span>
                                      <div className="tp-price-feature-tooltip">
                                        <p>Add gradient heading, button, pricing table testimonial etc.</p>
                                      </div>
                                    </div>
                                    <div className="tp-price-feature-item p-relative">
                                      <span>Access To Billwale:</span>
                                      <div className="tp-price-feature-tooltip">
                                        <p>Add gradient heading, button, pricing table testimonial etc.</p>
                                      </div>
                                    </div>
                                    <div className="tp-price-feature-item p-relative">
                                      <span>Generate E-Way Bill: </span>
                                      <div className="tp-price-feature-tooltip">
                                        <p>Add gradient heading, button, pricing table testimonial etc.</p>
                                      </div>
                                    </div>
                                    <div className="tp-price-feature-item p-relative">
                                      <span>Generate E-Invoicing:</span>
                                      <div className="tp-price-feature-tooltip">
                                        <p>Add gradient heading, button, pricing table testimonial etc.</p>
                                      </div>
                                    </div>
                                    <div className="tp-price-feature-item p-relative">
                                      <span>Generate and Print Barcode:</span>
                                      <div className="tp-price-feature-tooltip">
                                        <p>Add gradient heading, button, pricing table testimonial etc.</p>
                                      </div>
                                    </div>
                                    <div className="tp-price-feature-item p-relative">
                                      <span>SMS Marketing</span>
                                      <div className="tp-price-feature-tooltip">
                                        <p>Add gradient heading, button, pricing table testimonial etc.</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-8">
                                  <div className="tp-price-feature-info-item">
                                    <div className="tp-price-feature-info text-center">
                                      <span>Bill + Inventory</span>
                                    </div>
                                    <div className="tp-price-feature-info text-center">
                                      <span>1</span>
                                    </div>
                                    <div className="tp-price-feature-info text-center">
                                      <span>2</span>
                                    </div>
                                    <div className="tp-price-feature-info text-center">
                                      <span>Android,IOS & Web</span>
                                    </div>
                                    <div className="tp-price-feature-info text-center">
                                      <span>No</span>
                                    </div>
                                    <div className="tp-price-feature-info text-center">
                                      <span>No</span>
                                    </div>
                                    <div className="tp-price-feature-info text-center">
                                      <span>No</span>
                                    </div>
                                    <div className="tp-price-feature-info text-center">
                                      <span>0 SMS (Per Year)</span>
                                    </div>
                                  </div>
                                  <div className="tp-price-feature-info-item active">
                                    <div className="tp-price-feature-info text-center">
                                      <span>Bill + Inventory</span>
                                    </div>
                                    <div className="tp-price-feature-info text-center">
                                      <span>2</span>
                                    </div>
                                    <div className="tp-price-feature-info text-center">
                                      <span>5</span>
                                    </div>
                                    <div className="tp-price-feature-info text-center">
                                      <span>Android,IOS & Web</span>
                                    </div>
                                    <div className="tp-price-feature-info text-center">
                                      <span>No</span>
                                    </div>
                                    <div className="tp-price-feature-info text-center">
                                      <span>No</span>
                                    </div>
                                    <div className="tp-price-feature-info text-center">
                                      <span>No</span>
                                    </div>
                                    <div className="tp-price-feature-info text-center">
                                      <span>500 SMS (Per Year)</span>
                                    </div>
                                  </div>
                                  <div className="tp-price-feature-info-item">
                                    <div className="tp-price-feature-info text-center">
                                      <span>Bill + Inventory</span>
                                    </div>
                                    <div className="tp-price-feature-info text-center">
                                      <span>3</span>
                                    </div>
                                    <div className="tp-price-feature-info text-center">
                                      <span>8</span>
                                    </div>
                                    <div className="tp-price-feature-info text-center">
                                      <span>Android,IOS & Web</span>
                                    </div>
                                    <div className="tp-price-feature-info text-center">
                                      <span>Yes</span>
                                    </div>
                                    <div className="tp-price-feature-info text-center">
                                      <span>Yes</span>
                                    </div>
                                    <div className="tp-price-feature-info text-center">
                                      <span>Yes</span>
                                    </div>
                                    <div className="tp-price-feature-info text-center">
                                      <span>1000 SMS (Per Year)</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- tp-price-area-end --> */}

            </main>

            <Footer />

          </div>
        </div>
      </section>

    </>
  )
}
